__turbopack_context__.v({
  "badge": "FlagshipCard-module__Fw3O_W__badge",
  "card": "FlagshipCard-module__Fw3O_W__card",
  "contentsBox": "FlagshipCard-module__Fw3O_W__contentsBox",
});
